import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import EmailIcon from '@material-ui/icons/Email';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';

import Container from '../components/container'
import GoogleMap from '../components/google-map'
import styles from './contact.module.css'

class ContactPage extends React.Component {
  mapURL = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.051234542316!2d151.18430796412534!3d-33.88833430672074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x6a3aa3abbb927465!2sSusan%20Wakil%20Health%20Building%2C%20The%20University%20of%20Sydney!5e0!3m2!1sen!2sau!4v1620818640519!5m2!1sen!2sau`

  render() {
    const persons = this.props.data.contentfulSettings.personsOrder

    return (
      <div>

        <GoogleMap url={this.mapURL} />

        <Container
          size='large'
          padding='2rem'
        >

          <Typography
            variant="h4"
            gutterBottom
          >
            Contact Us
          </Typography>

          <Divider className={styles.divider} />

          <Grid
            container
            spacing={32}
            className={styles.grid}
          >

            {persons.map((person, index) => {
              return (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={4}
                  key={index}
                  className={styles.item}
                >

                  <Img
                    className={styles.image}
                    alt={person.name}
                    sizes={person.image.sizes}
                  />

                  {person.slug ? (
                    <Link to={person.slug}>
                      <Typography variant="h5" gutterBottom>
                        <span className={styles.link}>
                          {person.name}
                        </span>
                      </Typography>
                    </Link>
                  ) : (
                    <Typography variant="h5" gutterBottom>
                      {person.name}
                    </Typography>
                  )}

                  <Typography variant="h6" className={styles.paragraph} gutterBottom>
                    {person.title}
                  </Typography>

                  <Typography variant="body1" className={styles.paragraph} gutterBottom>
                    <a className={styles.link} href={`mailto:${person.email}`}>
                      {person.email}
                    </a>
                  </Typography>

                </Grid>
              )
            })}

          </Grid>

        </Container>

      </div>
    )
  }
}

export default ContactPage

export const pageQuery = graphql`
  query ContactPage {
    contentfulSettings {
      personsOrder {
        id
        name
        title
        email
        slug
        image {
          sizes(background: "rgb:000000") {
            ...GatsbyContentfulSizes_noBase64
          }
          file {
            details {
              image {
                height
                width
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/contact.js